// extracted by mini-css-extract-plugin
module.exports = {"collection":"Collection_collection__Y__pE"};